var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cmpMenu',{attrs:{"nav":_vm.nav}}),_c('cmpLoginTokenTimer',{ref:"myTimer"}),_c('div',{attrs:{"id":"wapper"}},[_c('hr',{attrs:{"id":"tophr"}}),_c('div',{staticStyle:{"padding-bottom":"40px"}},[_c('router-view')],1)]),_c('cmpFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }